export const VUEX_PRODUCTS_FETCH = 'VUEX_PRODUCTS_FETCH'
export const VUEX_PRODUCTS_FETCH_SUCCESS = 'VUEX_PRODUCTS_FETCH_SUCCESS'
export const VUEX_PRODUCTS_FETCH_FAILURE = 'VUEX_PRODUCTS_FETCH_FAILURE'
export const VUEX_PRODUCTS_CLEAR = 'VUEX_PRODUCTS_CLEAR'

export const VUEX_PRODUCT_STYLE_TEARSHEET = 'VUEX_PRODUCT_STYLE_TEARSHEET'
export const VUEX_PRODUCT_STYLE_TEARSHEET_FAILURE = 'VUEX_PRODUCT_STYLE_TEARSHEET_FAILURE'
export const VUEX_PRODUCT_STYLE_TEARSHEET_SUCCESS = 'VUEX_PRODUCT_STYLE_TEARSHEET_SUCCESS'
